// File: apps/web/src/main.tsx

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './styles/index.css';
import { registerServiceWorker, setupInstallPrompt } from './utils/serviceWorker';

// Initialize i18n (must be imported before rendering)
import './i18n';

// Register service worker for PWA support
if (import.meta.env.PROD) {
  registerServiceWorker();
  setupInstallPrompt();
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
